import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TSvgIconProps } from '../icon.component';

const PdsEdit = forwardRef(
  ({ ...props }: TSvgIconProps, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3396 0.584399C16.5604 -0.194803 15.2971 -0.194798 14.5179 0.584405L11.7455 3.35682C11.743 3.35922 11.7406 3.36164 11.7382 3.36406L1.03188 14.0704C0.718143 14.3842 0.517931 14.7935 0.462896 15.2338L0.00760869 18.8759C-0.0306686 19.1822 0.0745706 19.4889 0.292776 19.7071C0.510981 19.9253 0.817708 20.0305 1.12392 19.9923L4.76609 19.537C5.20637 19.482 5.61574 19.2818 5.92948 18.968L19.4155 5.482C20.1946 4.7028 20.1946 3.43949 19.4155 2.66029L17.3396 0.584399ZM13.8602 4.07056L15.9287 2.00197L17.9979 4.07115L15.9311 6.13794L13.8602 4.07056ZM2.15164 17.8482L2.44725 15.4835L12.4453 5.48539L14.5144 7.55456L4.51641 17.5527L2.15164 17.8482Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default PdsEdit;
